// import { onUnmounted, ref } from 'vue';
import { pushStatsig } from '.';
import {
    // MetaData,
    StatsigEvent,
} from './types';
//import { ErrorHandlingType } from '@/api/Errors/errors.interfaces';
// import { isNotNil } from '@shared/utils/value';
import { StatsigClient } from '@statsig/js-client';
import { SeatAvailability } from '@/api/Cart/cart.interfaces';
import { configBase } from '@/config/base';

/*export const logStatsigError = (
    error: string | Event = 'unhandledrejection',
    errorType: ErrorHandlingType
) => {
    const metadata = { error };

    if (errorType === ErrorHandlingType.UnhandledError) {
        pushStatsig({
            eventName: StatsigEventName.GENERAL_ERROR,
            metadata,
        });
    } else {
        pushStatsig({
            eventName: StatsigEventName.CUSTOM_ERROR,
            metadata,
        });
    }
};*/

// export const logStatsigPerformanceAPI = (
//     id: string,
//     seconds: number,
//     error: any | undefined
// ) => {
//     const getErrorMessage = (error: any): string | undefined => {
//         if (!isNotNil(error)) {
//             return undefined;
//         }
//
//         if (typeof error === 'string') {
//             return error;
//         } else if (error && typeof error.message === 'string') {
//             return error.message;
//         } else {
//             return 'Unknown error';
//         }
//     };
//
//     const metadata: MetaData = {
//         api_id: id,
//         api_load_seconds: seconds,
//         api_error: isNotNil(error) ?? false,
//         api_error_message: getErrorMessage(error),
//     };
//
//     pushStatsig({
//         eventName: StatsigEvent.PERFORMANCE_API,
//         metadata,
//     });
// };

export function getStatsigParameter(
    experiment: string,
    param: string,
    defaultValue: string | boolean
) {
    return StatsigClient.instance(configBase.tracking.statsig.key)
        .getExperiment(experiment)
        ?.get(param, defaultValue);
}

// export function useStatsigPerformanceAPI(id: string) {
//     const seconds = ref(0);
//     let interval: any | null = null;
//
//     const startPerformance = (ms = 1000) => {
//         seconds.value = 0;
//         interval = setInterval(() => {
//             seconds.value += 1;
//         }, ms);
//     };
//
//     const stopPerformance = (error?: any) => {
//         if (interval !== null) {
//             interval = null;
//             clearInterval(interval);
//             logStatsigPerformanceAPI(id, seconds.value, error);
//         }
//     };
//
//     onUnmounted(() => stopPerformance());
//
//     return {
//         startPerformance,
//         stopPerformance,
//     };
// }

export const logStatsigTranslationMissingKey = (lang: string, key: string) => {
    const metadata = {
        translation_key: key,
        translation_lang: lang,
    };

    pushStatsig({
        eventName: StatsigEvent.TRANSLATION_MISSING_KEY,
        metadata,
    });
};

export const logStatsigSeatingAvailabilityStatus = (
    status: SeatAvailability,
    carriers: string[]
) => {
    const metadata = {
        seating_products_carriers: carriers,
        seating_availability_status: status,
    };

    pushStatsig({
        eventName: StatsigEvent.SEATING_AVAILABILITY_STATUS,
        metadata,
    });
};
